import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, HostBinding, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'bb-check',
	templateUrl: './bb-check.component.html',
	styleUrls: ['./bb-check.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbCheckComponent),
		multi: true
	}]

})

export class BbCheckComponent implements ControlValueAccessor, OnInit {
	@HostBinding('style.border-style') get getBorderStyle() {
		return this.theme === 'light2-theme' || this.theme === 'dark-theme' ? 'none' : null;
	}
	@HostBinding('class.dark-theme') get isDarkTheme() {
		return this.theme === 'dark-theme';
	}
	@HostBinding('class.rb-theme') get isRbTheme() {
		return this.theme === 'rb';
	}

	@Input() checked = false;
	@Input() disabled = false;
	@Input() partial = false;
	@Input() useExclude = false;
	@Input() trueValue: string | boolean;
	@Input() falseValue: string | boolean;
	@Input() defaultValue: any;
	@Input() theme?: 'dark-theme' | 'light2-theme' | 'rb';
	@Input() color?: string;
	@Input() falseColor?: string;
	@Output() onChanged = new EventEmitter<any>();

	el: HTMLElement;
	propagateChange: any;
	modelValue: string | boolean;

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {
		if (this.el.parentNode) {
			const parent = (this.el.parentNode as HTMLElement);

			if (parent.tagName === 'LABEL') {
				parent.onclick = (e) => {
					e.stopPropagation();
					this.clicked(e);
				};
			}
		}

		this.el.onclick = (e) => {
			e.stopPropagation();
			this.clicked(e);
		};
	}

	clicked(e: Event) {
		if (this.disabled) {
			return;
		}

		this.checked = !this.checked;

		if (typeof this.trueValue !== 'undefined') {
			this.modelValue = this.checked ? this.trueValue : this.falseValue;
		} else {
			this.modelValue = !!this.checked;
		}

		if (typeof this.propagateChange !== 'undefined') {
			this.propagateChange(this.modelValue);
		}

		this.onChanged.emit(this.modelValue);

	}

	writeValue(value: any) {
		if (this.trueValue && value === this.trueValue) {
			this.checked = true;
		} else if (this.falseValue && value === this.falseValue) {
			this.checked = false;
		} else if (typeof value === 'undefined' && typeof this.defaultValue !== 'undefined' && this.defaultValue !== null) {
			this.checked = this.trueValue ? this.trueValue === this.defaultValue : !!this.defaultValue;
		} else {
			if (typeof this.trueValue === 'string') {
				this.checked = value === this.trueValue;
			} else {
				this.checked = !!value;
			}
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
